import { render, staticRenderFns } from "./ConfigSmsEndPersonPopup.vue?vue&type=template&id=01ca9217&"
import script from "./ConfigSmsEndPersonPopup.vue?vue&type=script&lang=js&"
export * from "./ConfigSmsEndPersonPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports